/**
 * PURPOSE: Consumir la auditoría administrativa desde Winscore.
 * RESPONSIBILITIES: Listar actividad, consultar no leídos y confirmar lectura.
 * COLLABORATORS: AuditNotificationPanel.jsx, Navbar.jsx y backend /api/audit.
 * ROUTE: winscore/src/services/auditNotificationService.js
 */
import httpService from "./httpService.js";

export const getAuditNotifications = async (params = {}) => {
  const response = await httpService.get("/api/audit/notifications", { params });
  return response.data;
};

export const getAuditFilterOptions = async () => {
  const response = await httpService.get("/api/audit/notifications/filter-options");
  return response.data;
};

export const getAuditUnreadCount = async () => {
  const response = await httpService.get("/api/audit/notifications/unread-count");
  return response.data;
};

export const markAuditNotificationsRead = async (auditId = null) => {
  const response = await httpService.patch("/api/audit/notifications/read", { auditId });
  return response.data;
};
